import { render } from "./MitarbeiterIndexDetails.vue?vue&type=template&id=e932da94"
import script from "./MitarbeiterIndexDetails.vue?vue&type=script&lang=ts"
export * from "./MitarbeiterIndexDetails.vue?vue&type=script&lang=ts"

import "./MitarbeiterIndexDetails.vue?vue&type=style&index=0&id=e932da94&lang=scss"
script.render = render

export default script